const currencyFormater = (value: number, empty: boolean = false) => {
    if (value === 0 && empty) {
        return "";
    }
    return new Intl.NumberFormat("en-IN").format(
        parseFloat(Math.round(value).toFixed(0).toLocaleString())
    );
};
export default currencyFormater;
